import React from 'react';
import { PRICE, REGULAR_PRICE, SAVINGS, TOTAL_VALUE, valueStack } from '../data/valueStack';
import { Countdown } from './Countdown';
import { CtaButton } from './CtaButton';
import { Eyebrow } from './Eyebrow';
export function FinalCall() {
  return <section aria-labelledby="final-heading" className="border-y border-night-600 bg-night-950 py-14 sm:py-24" data-id="element-105" data-mp="2ynszo4mf99br">
      <div className="mx-auto grid max-w-shell gap-10 px-5 sm:px-6 lg:grid-cols-2 lg:items-center lg:gap-20" data-id="element-106" data-mp="2tmlmtr5f9jy8">
        <div data-id="element-107" data-mp="3md401kzv11pd">
          <Eyebrow data-id="element-108" data-mp="3mclwe3avbl7f">Ostatnie odliczanie</Eyebrow>
          <h2 id="final-heading" className="mt-4 font-display text-4xl leading-[0.98] text-cream sm:text-6xl" data-id="element-109" data-mp="3mdwze0whooxh">
            Kompletny pakiet, <span className="text-amber" data-id="element-110" data-mp="3dcfmssiaj5dj">cena premierowa</span>
          </h2>
          <div className="mt-7" data-id="element-111" data-mp="3dc5rcpeh860g">
            <Countdown initialSeconds={86347} size="lg" data-id="element-112" data-mp="25ym0d3f58fpg" />
          </div>
          <p className="mt-6 max-w-sm text-sm text-cream-muted" data-id="element-113" data-mp="25wrffp3vgnld">
            Gdy licznik dojdzie do zera, cena wróci do {REGULAR_PRICE}.
          </p>
        </div>
        <div className="rounded-2xl border border-amber/50 bg-night-800 p-6 sm:p-10" data-id="element-114" data-mp="i5tl5lelhagq">
          <p className="text-xs font-semibold uppercase tracking-label text-amber sm:text-sm" data-id="element-115" data-mp="n2jza36u9vzi">
            6 tomów + 6 bonusów
          </p>
          <dl className="mt-5 border-y border-night-600 py-4" data-id="element-116" data-mp="95wrf5dcllet">
            {valueStack.map(line => <div key={line.label} className="flex items-baseline justify-between gap-4 py-1.5" data-id="element-117" data-mp="d79x9fgfxolq">
                <dt className="text-xs text-cream-muted" data-id="element-118" data-mp="3vhljt63nv7pr">{line.label}</dt>
                <dd className="text-xs font-semibold tabular-nums text-cream-soft" data-id="element-119" data-mp="46boykyyyuxc">{line.value}</dd>
              </div>)}
            <div className="flex items-baseline justify-between gap-4 pt-2" data-id="element-120" data-mp="3lje7x1o8bfum">
              <dt className="text-[10px] font-semibold uppercase tracking-label text-cream-muted" data-id="element-121" data-mp="3qklgh2y74j2c">
                Łączna realna wartość
              </dt>
              <dd className="text-xs font-semibold tabular-nums text-cream-muted line-through" data-id="element-122" data-mp="3hjx0i2p8s8mt">{TOTAL_VALUE}</dd>
            </div>
          </dl>
          <p className="mt-5 flex items-baseline gap-3" data-id="element-123" data-mp="1n5i1p7g29g35">
            <span className="font-display text-6xl leading-none text-amber sm:text-7xl" data-id="element-124" data-mp="1icgm0x815cii">{PRICE}</span>
            <span className="font-display text-xl leading-none text-cream-muted line-through" data-id="element-125" data-mp="1denfg32teghp">{TOTAL_VALUE}</span>
          </p>
          <p className="mt-3 text-sm font-semibold text-amber-light" data-id="element-126" data-mp="19dv4n5eao3jb">Oszczędzasz dziś {SAVINGS}</p>
          <div className="mt-7" data-id="element-127" data-mp="261hwsr4c4zqy">
            <CtaButton size="lg" fullWidth data-id="element-128" data-mp="2136lsd2b0j75">
              Tak, chcę to teraz
            </CtaButton>
          </div>
          <ul className="mt-6 space-y-1.5 text-xs text-cream-muted" data-id="element-129" data-mp="1x138rjzzl6jr">
            <li data-id="element-130" data-mp="1x3fodqi9v4tn">Płatność jednorazowa &middot; Bez subskrypcji</li>
            <li data-id="element-131" data-mp="1s202xxc6mwaq">Natychmiastowy dostęp do wszystkich materiałów</li>
            <li data-id="element-132" data-mp="lmz7rtuzei57">10-dniowa gwarancja satysfakcji</li>
          </ul>
        </div>
      </div>
    </section>;
}